module.exports = __webpack_public_path__ + "img/claims-image-bg.5acad942.png";